import axios from 'axios'
import _ from 'lodash'

const initState = {
  objectViews: [],
}

export const state = Object.assign({}, _.cloneDeep(initState))

export const mutations = {
  addObjectView(state: any, view: any) {
    const existView = state.objectViews.find((el: any) => el.viewId === view.viewId)

    if (existView === undefined) {
      state.objectViews.push(view)
    }
  },

  delObjectView(state: any, viewId: any) {
    for (const [i, v] of state.objectViews.entries()) {
      if (v.viewId === viewId) {
        state.objectViews.splice(i, 1)
        break
      }
    }
  },

  resetState(state: any) {
    Object.assign(state, _.cloneDeep(initState))
  },
}

export const actions = {
  resetState({ commit }: any) {
    commit('resetState')
  },

  addPrint({ commit }: any, payload: any) {
    const viewId = payload.name + '-' + payload.id
    const newObject = _.cloneDeep(payload.object)
    newObject.originalId = payload.id
    newObject.id = viewId
    newObject.isNew = true
    newObject.routeOwner = payload.routeOwner
    newObject.isPrintAndClosed = payload.isPrintAndClosed

    commit('addObjectView', { viewId, object: newObject })
  },
}

export const getters = {
  objectView: (state: any) => (viewId: any) => {
    return state.objectViews.find((el: any) => el.viewId === viewId)
  },
}
